angular.module('Itao.IndicatorMap').directive('donutChart', function (d3, mapConfig) {
  'use strict';

  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;

  var donutChart = function () {
    var
      svgHeight = 135,
      svgWidth,
      color = '',
      transformToTimeFormat = false,
      margin = {top: 5, right: 5, bottom: 5, left: 5},
      arcWidth = 32,
      numberFormat = germanNumberFormat(',.' + mapConfig.relativeIndicatorsDecimalPlaces + 'f');

    var chart = function (selection) {
      selection.each(function (data) {

        var container = d3.select(this).datum([data]).classed('donut-chart', true);

        svgWidth = svgWidth ? svgWidth : selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars

        var width = svgWidth - margin.left - margin.right,
          height = svgHeight - margin.top - margin.bottom,
          outerRadius = Math.min(width, height) / 2;

        var addHeight = transformToTimeFormat ? 60 : 0;
        var svg = container.selectAll('svg').data([data]);

        var svgEnter = svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + (svgHeight + addHeight))
          .attr('height', (svgHeight + addHeight))
          .attr('width', svgWidth); // set viewBox of the svg

        var g = svg.selectAll('g').data([data]);
        var gEnter = g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').attr('transform', 'translate(' + (svgWidth / 2) + ',' + ((svgHeight + addHeight) / 2) + ')');

        var donutArc = d3.svg.arc()
          .innerRadius(outerRadius - arcWidth)
          .outerRadius(outerRadius)
          .startAngle(0)
          .endAngle(function (d) {
            if (d == null) {
              return 0;
            }
            return 2 * Math.PI * (d / 100);
          });

        var background = gEnter.selectAll('.background')
          .data([100]);

        background.enter().append('path')
          .attr('class', 'background')
          .attr('fill', '#eee')
          .attr('d', donutArc);

        var donut = g.selectAll('.donut')
          .data(data);

        donut
          .enter()
          .append('path')
          .attr('fill', color)
          .attr('d', donutArc(0))
          .attr('class', 'donut');

        donut
          .attr('d', donutArc);

        var transformToTime = function (number) {
          number = 9.5;
          var hoursAndMinutes = number.toString().split('.');
          var hours = hoursAndMinutes[0];
          var minutes = hoursAndMinutes[1] ? (hoursAndMinutes[1] / 10 * 6).toString().substr(0, 2) : '00';
          minutes = minutes.length < 2 ? minutes + '0' : minutes;

          return hours + ":" + minutes;
        };

        var label = g.selectAll('.donut-label')
          .data(data);

        label.enter()
          .append('text')
          .attr('text-anchor', 'middle')
          .attr('class', 'donut-label')
          .attr('dy', '0.4em');

        label.text(function (d) {
          if (transformToTimeFormat && d !== null) {
            return transformToTime(d);
          } else {
            return d == null ? '—' : numberFormat(d);
          }
        });

        if (transformToTimeFormat) {
          var footer = g.selectAll('.donut-footer')
            .data(data);

          footer.enter()
            .append('text')
            .attr('text-anchor', 'middle')
            .attr('class', 'donut-footer')
            .attr('dy', '6.5em');

          footer.text(function (d) {
            if (transformToTimeFormat && d !== null) {
              return "Durchschnittliche Öffnungsdauer aller KiTas: " + transformToTime(d) + " Stunden pro Tag (Median) ";
            } else {
              return d == null ? '—' : numberFormat(d);
            }
          });
        }
      });
    };

    /**
     * getter/setter for color
     * @param {Function} [newColor] new color function
     * @returns {*}
     */
    chart.color = function (newColor) {
      if (!arguments.length) {
        return color;
      } else {
        color = newColor;
        return chart;
      }
    };

    /**
     * getter/setter for color
     * @param {Function} [newSvgWidth] new color function
     * @returns {*}
     */
    chart.svgWidth = function (newSvgWidth) {
      if (!arguments.length) {
        return svgWidth;
      } else {
        svgWidth = parseInt(newSvgWidth);
        svgHeight = svgWidth;
        return chart;
      }
    };

    /**
     * getter/setter for newTransformToTimeFormat
     * @param {Function} [newTransformToTimeFormat] new transformToTimeFormat function
     * @returns {*}
     */
    chart.transformToTimeFormat = function (newTransformToTimeFormat) {
      if (!arguments.length) {
        return transformToTimeFormat;
      } else {
        transformToTimeFormat = newTransformToTimeFormat;
        return chart;
      }
    };

    return chart;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'donutChart.html',
    scope: {
      selectedDataLayer: '=',
      selectedDistrict: '=',
      timeFormat: '@',
      indicatorUid: '@',
      color: '&',
      svgWidth: '@'
    },
    link: function (scope, element) {

      var donutChartFunction = donutChart();

      /**
       * update the chart from one of the watchers
       */
      var rerender = function () {
        if (scope.selectedDataLayer != null && scope.selectedDistrict != null && scope.indicatorUid != null && scope.color != null && scope.selectedDataLayer.hasOwnProperty(scope.selectedDistrict.uid)) {
          var value = scope.selectedDataLayer[scope.selectedDistrict.uid][scope.indicatorUid];

          donutChartFunction
            .transformToTimeFormat(scope.timeFormat)
            .svgWidth(scope.svgWidth)
            .color(scope.color);

          d3.select(element.find('.widget-inner:first')[0])
            .data([[value]])
            .call(donutChartFunction);
        }
      };

      var selectedDataLayerWatcher = scope.$watch('selectedDataLayer', rerender);
      var selectedDistrictWatcher = scope.$watch('selectedDistrict', rerender);
      var indicatorSetsIndicators = scope.$watchCollection('indicatorSets', rerender);
      var colorWatcher = scope.$watch('color', rerender);
      var transformToTimeFormatWatcher = scope.$watch('transformToTimeFormat', rerender);

      // remove watcher on destroy
      element.on('$destroy', function () {
        selectedDataLayerWatcher();
        transformToTimeFormatWatcher();
        selectedDistrictWatcher();
        indicatorSetsIndicators();
        colorWatcher();
      });
    }
  };
});
